document.addEventListener("DOMContentLoaded", () => {
  let pageHasRecomendations =
    document.querySelector(".product-recommendations") || false;
  let timeout = pageHasRecomendations ? 2000 : 0;

  setTimeout(function () {
    let quickViewModal = document.querySelector(".quick-view-container");

    if (quickViewModal) {
      let quickViewModalInner = quickViewModal.querySelector(".inner");
      let quickViewControls = document.querySelectorAll("[open-quick-view]");
      let quickViewClose = quickViewModal.querySelector(".close");

      let sectionName = "v2-main-product";
      // let sectionName = "test-section";

      quickViewControls.forEach((control) => {
        let handle = control.getAttribute("data-product-handle");

        if (handle) {
          control.addEventListener("click", () => {
            window.axios
              .get(window.Shopify.routes.root+`/products/${handle}?sections=${sectionName}`, {})
              .then(function (response) {
                // Success
                let script_index = 2;
                let html = response.data[`${sectionName}`];

                // this section gets the correct js returned in the section rendering API call and gets the js within the document on load so that we can rerun it (eval)
                let script_parts = html.split("<script>");
                // console.log("🚀 ~ file: product-quick-view-modal.js:29 ~ html", html)
                script = script_parts[script_index].replace("</script>", "");
                script = script.replace("</div>", "");
                script = script.replace('document.addEventListener("DOMContentLoaded", function() {', "");
                let closingBraceLocation = script.lastIndexOf("})");
                script = script.substring(0, closingBraceLocation)

                if (quickViewModalInner && html) {
                  quickViewModalInner.innerHTML = html;

                  eval(script);

                  

                  // init sliders
                  let gallery_thumbs_swiper = new window.swiper(
                    ".inner .thumb-swiper",
                    {
                      spaceBetween: 15,
                      slidesPerView: 4,
                      freeMode: true,
                      watchSlidesProgress: true,
                      breakpoints: {
                        992: {
                          slidesPerView: 4,
                          direction: "vertical",
                        },
                      },
                    }
                  );

                  let gallery_swiper = new window.swiper(
                    ".inner .main-swiper",
                    {
                      spaceBetween: 20,
                      navigation: {
                        nextEl: ".inner .swiper-button-next",
                        prevEl: ".inner .swiper-button-prev",
                      },
                      thumbs: {
                        swiper: gallery_thumbs_swiper,
                      },
                      on: {
                        init: function () {

                          let check_width = setInterval(() => {
                            setThumbHeight()
                          }, 200);

                          function setThumbHeight() {
                            let main_swiper_slide = document.querySelector('.inner .main-swiper-slide');
                            let thumb_swiper_slide = document.querySelector('.inner .swiper-slide.thumb');
                            let thumb_swiper = document.querySelector('.inner .thumb-swiper');

                            let main_swiper_width = main_swiper_slide.offsetWidth;

                            main_swiper_slide.style.height = main_swiper_width + 'px';

                            if (main_swiper_width > 0) {

                              clearInterval(check_width);

                              thumb_swiper.style.cssText = "position: relative;opacity:1";

                              if (window.innerWidth > 991.98) {
                                thumb_swiper.style.height = main_swiper_width + 'px';
                              }
                            }
                          }

                          document.querySelector('.inner .gallery-container').style.opacity = 1;

                          window.addEventListener('resize', () => {

                            let main_swiper_slide = document.querySelector('.inner .main-swiper');
                            let thumb_swiper_slide = document.querySelector('.inner .swiper-slide.thumb');
                            let thumb_swiper = document.querySelector('.inner .thumb-swiper');

                            let main_swiper_width = main_swiper_slide.offsetWidth;

                            main_swiper_slide.style.height = main_swiper_width + 'px';

                            if (window.innerWidth > 991.98) {

                              thumb_swiper.style.height = main_swiper_width + 'px';

                            }

                          });

                        }
                      },
                    }
                  );

                  // add listeners to product form
                  let productForm = quickViewModalInner.querySelector(
                    '[action="/cart/add"]'
                  );

                  if (productForm) {
                    productForm.addEventListener("submit", function (e) {
                      e.preventDefault();

                      let quantity = productForm.querySelector(
                        "input.quantity-selector"
                      ).value;
                      let id = productForm.querySelector("#product-id").value;

                      if (quantity && id) {
                        window.cart.add({ items: [{ "id": id, "quantity": quantity }] });
                      }
                    });
                  }

                  // add listener for read more
                  let read_more = quickViewModalInner.querySelector(
                    ".product-description-container[read-more-qf]"
                  );

                  if (read_more) {
                    let read_more_control =
                      read_more.querySelector(".read-more");
                    let excerpt = read_more.querySelector("span.excerpt");
                    let full = read_more.querySelector("span.full");

                    read_more_control.addEventListener("click", () => {
                      if (read_more.classList.contains("active")) {
                        read_more.classList.remove("active");
                        read_more_control.innerHTML = "Read more";
                      } else {
                        read_more.classList.add("active");
                        read_more_control.innerHTML = "Read less";
                      }
                    });
                  }

                  // Show quick view modal
                  quickViewModal.classList.add("active");
                }
              })
              .catch(function (error) {
                // handle error
                window.log("Error:", error);
              })
              .then(function () {
                // always executed
                window.log("Complete");
              });
          });
        }
      });

      quickViewClose.addEventListener("click", () => {
        quickViewModal.classList.remove("active");
      });
    }
  }, timeout);
});
